import statusHeaderActionTypes from '../../../constants/actions/dossier/common/statusHeader'

export function initialState () {
  return {
    isFolded: false,
    height: 0
  }
}

function toggleTimeline (state, { isFolded }) {
  return {
    ...state,
    isFolded: !state.isFolded
  }
}

function setStatusHeaderHeight (state, { height }) {
  return {
    ...state,
    height
  }
}

function resetStatusHeader (state) {
  return initialState()
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case statusHeaderActionTypes.TOGGLE_TIMELINE:
      return toggleTimeline(state, action)
    case statusHeaderActionTypes.SET_STATUS_HEADER_HEIGHT:
      return setStatusHeaderHeight(state, action)
    case statusHeaderActionTypes.RESET_STATUS_HEADER:
      return resetStatusHeader(state, action)
    default:
      return state
  }
}
